import React, { useEffect, useState } from "react";

import withRouter from "./withRouter";

// ============================================================================
// Back to Top Button Component
// ============================================================================
const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className="btn btn-danger btn-icon"
      id="back-to-top"
      aria-label="Scroll back to top"
      style={{
        position: "fixed",
        bottom: "45px",
        right: "50px",
        zIndex: 9999,
        display: isVisible ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        width: "37px",
        height: "37px",
      }}>
      <i className="ri-arrow-up-line"></i>
    </button>
  );
};

// ============================================================================
// Main RightSidebar Component
// ============================================================================
const RightSidebar = (props) => {
  return (
    <React.Fragment>
      <BackToTopButton />
    </React.Fragment>
  );
};

export default withRouter(RightSidebar);